export default __webpack_public_path__ + "static/media/silver-piece.e60116c9.svg";